/**
 * Routes a locked session may use while the unlock dialog is minimized.
 * Anything else reopens the dialog. These pages do not need the wrapping key.
 * Space routes render the read-only guest view while locked.
 */

export const SESSION_LOCK_PUBLIC_PATHS = [
  '/about/learn',
  '/about/roadmap',
  '/about/updates',
  '/download',
  '/legal-policies',
  '/s',
] as const;

export function isSessionLockPublicPath(pathname: string): boolean {
  return SESSION_LOCK_PUBLIC_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}
